import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { GenericErrorContent } from '../../models/generic-error-content.model';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'seth-generic-error',
    imports: [
        MatButtonModule,
        MatIconModule,
    ],
    templateUrl: './generic-error.component.html',
    styleUrl: './generic-error.component.scss',
})
export class GenericErrorComponent {
  snackBarRef: MatSnackBarRef<unknown> = inject(MatSnackBarRef);
  data: GenericErrorContent = inject(MAT_SNACK_BAR_DATA);
}
